import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MyDataService } from 'src/app/services/data/data.service';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';
import { UbicacionesService } from 'src/app/services/ubicaciones/ubicaciones.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss'],
})
export class PerfilComponent implements OnInit {
  private destroyed$ = new Subject<void>();

  public formDatos: FormGroup;
  public formDireccion: FormGroup;

  paises: any = [];
  provincias: any = [];
  poblaciones: any = [];

  constructor(
    private _formBuilder: FormBuilder,
    private ubicacionesSvc: UbicacionesService,
    private userSvc: UserService,
    private dataSvc: MyDataService,
    private snackBarService: SnackBarService,
    private translocoService: TranslocoService
  ) {
    this.formDatos = this._formBuilder.group({
      nombre: ['', [Validators.required, Validators.maxLength(250)]],
      apellidos: ['', [Validators.maxLength(250)]],
    });

    this.formDireccion = this._formBuilder.group({
      pais: ['', [Validators.maxLength(200)]],
      provincia: ['', [Validators.maxLength(200)]],
      poblacion: ['', [Validators.maxLength(200)]],
      direccion: ['', [Validators.required, Validators.maxLength(200)]],
      codigoPostal: ['', [Validators.required, Validators.maxLength(200)]],
      phone: ['', [Validators.maxLength(500)]],
    });
  }

  ngOnInit(): void {
    this.setDataForms();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  showSnackBarSuccess(mensaje: string) {
    this.snackBarService.openSnackBarSuccess(mensaje);
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje);
  }

  setDataForms() {
    const user = this.dataSvc.getUserPlatform();
    if (user) {
      console.log(user);
      this.formDatos.get('nombre')?.setValue(user?.cliente?.nombre);
      this.formDatos.get('apellidos')?.setValue(user?.cliente?.apellido);
      this.formDireccion.get('direccion')?.setValue(user?.cliente?.direccion);
      this.formDireccion.get('codigoPostal')?.setValue(user?.cliente?.cp);
      this.formDireccion.get('phone')?.setValue(user?.cliente?.tlf_contacto);
      // this.getPaises(user.direccion.id_pais);
      // this.getProvincias(user.direccion.id_pais, user.direccion.id_provincia);
      // this.getPoblaciones(
      //   user.direccion.id_provincia,
      //   user.direccion.id_localidad
      // );
    } else {
      this.userSvc
        .getPerfil()
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
          (data) => {
            console.log(data);
            this.formDatos.get('nombre')?.setValue(data?.cliente?.nombre);
            this.formDatos.get('apellidos')?.setValue(data?.cliente?.apellido);
            this.formDireccion
              .get('direccion')
              ?.setValue(data?.cliente?.direccion);
            this.formDireccion.get('codigoPostal')?.setValue(data?.cliente?.cp);
            this.formDireccion
              .get('phone')
              ?.setValue(data?.cliente?.tlf_contacto);
            // this.getPaises(data.direccion.id_pais);
            // this.getProvincias(
            //   data.direccion.id_pais,
            //   data.direccion.id_provincia
            // );
            // this.getPoblaciones(
            //   data.direccion.id_provincia,
            //   data.direccion.id_localidad
            // );
          },
          (err) => {
            console.log(err);
            this.showSnackBarError(
              this.translocoService.translate('profile.error.getProfile')
            );
          }
        );
    }
  }

  getPaises(pais: number) {
    this.ubicacionesSvc
      .getPaises()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (data) => {
          this.paises = data;
          this.formDireccion.get('pais')?.setValue(pais);
        },
        (err) => {
          console.log(err);
          this.showSnackBarError(
            this.translocoService.translate('profile.error.getCountries')
          );
        }
      );
  }

  changePais(event: any) {
    console.log(event);
    this.formDireccion.get('provincia')?.setValue('');
    this.formDireccion.get('poblacion')?.setValue('');
    this.getProvincias(event);
  }

  getProvincias(pais: number, provincia?: number) {
    this.ubicacionesSvc
      .getProvincias(pais)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (data) => {
          this.provincias = data;
          if (provincia) {
            this.formDireccion.get('provincia')?.setValue(provincia);
          }
        },
        (err) => {
          console.log(err);
          this.showSnackBarError(
            this.translocoService.translate('profile.error.getProvinces')
          );
        }
      );
  }

  changeProvincia(event: any) {
    console.log(event);
    this.formDireccion.get('poblacion')?.setValue('');
    this.getPoblaciones(event);
  }

  getPoblaciones(provincia: any, poblacion?: number) {
    this.ubicacionesSvc
      .getPoblaciones(provincia)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (data) => {
          this.poblaciones = data;
          if (poblacion) {
            this.formDireccion.get('poblacion')?.setValue(poblacion);
          }
        },
        (err) => {
          console.log(err);
          this.showSnackBarError(
            this.translocoService.translate('profile.error.getCities')
          );
        }
      );
  }

  updateUser() {
    this.userSvc
      .updatePerfil(this.formDatos.value, this.formDireccion.value)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (data) => {
          console.log(data);
          this.showSnackBarSuccess(
            this.translocoService.translate('profile.error.updateSuccess')
          );
        },
        (err) => {
          console.log(err);
          this.showSnackBarError(
            this.translocoService.translate('profile.error.updateProfile')
          );
        }
      );
  }
}
